/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ClientLogsPostRequest } from '../models';
/**
 * ClientLogsApi - axios parameter creator
 * @export
 */
export const ClientLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send Logs of User
         * @param {ClientLogsPostRequest} [clientLogsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogsPost: async (clientLogsPostRequest?: ClientLogsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/client_logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientLogsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientLogsApi - functional programming interface
 * @export
 */
export const ClientLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Send Logs of User
         * @param {ClientLogsPostRequest} [clientLogsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientLogsPost(clientLogsPostRequest?: ClientLogsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientLogsPost(clientLogsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientLogsApi - factory interface
 * @export
 */
export const ClientLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientLogsApiFp(configuration)
    return {
        /**
         * Send Logs of User
         * @param {ClientLogsPostRequest} [clientLogsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogsPost(clientLogsPostRequest?: ClientLogsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.clientLogsPost(clientLogsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientLogsApi - object-oriented interface
 * @export
 * @class ClientLogsApi
 * @extends {BaseAPI}
 */
export class ClientLogsApi extends BaseAPI {
    /**
     * Send Logs of User
     * @param {ClientLogsPostRequest} [clientLogsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientLogsApi
     */
    public clientLogsPost(clientLogsPostRequest?: ClientLogsPostRequest, options?: AxiosRequestConfig) {
        return ClientLogsApiFp(this.configuration).clientLogsPost(clientLogsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
